import React from 'react';

const setCookie = (name, value, params = {}) => {
  const options = {
    path: '/',
    ...params,
  };

  if (options.expires && options.expires.toUTCString) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const optionKey in options) {
    updatedCookie += `; ${optionKey}`;
    const optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += `=${optionValue}`;
    }
  }

  document.cookie = updatedCookie;
};

const getCookie = (name) => {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`,
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

const CookieConsentContext = React.createContext(undefined);

const CookieConsentProvider = ({cookieConsent, setCookieConsent, children}) => <CookieConsentContext.Provider value={{cookieConsent, setCookieConsent}}>{children}</CookieConsentContext.Provider>;

export {
  setCookie, getCookie, CookieConsentContext, CookieConsentProvider,
};
